module.exports = __webpack_public_path__ + "img/banner-background.538ae58b.png";